import templates from '../../core/templates';
import api from "../../api";
import infoBoard from "../../core/infoboard";
import worldMap from '../../core/map';
import translate from "../../core/tools/translate";
import { customScrollbar, isLayerEnabled } from "../../shared";
import environment from '../../environment';
import { selectMarker } from '../../shared/map';
import { CONFIG } from '../../../config';

const name = 'DealershipAfterSales';

const LayerControls = (name) => require('../../controls').get(name);
const LayerInfo = (name) => require('./../index').get(name);

const currentLayer = () => LayerControls(name).getLayer();

const _getContainer = () =>
    infoBoard.createContainer({
        id: 'dealershipaftersales',
        name: translate('Common.DealershipAfterSales'),

    });

const _getInfo = (feature) => {
    const data = {};
    const {
        geometry: { coordinates },
        properties: {
            Id,
            Name,
            AddressComplement,
            BrandName,
            Neighborhood,
            StateAcronym,
            City,
            Zipcode,
            GroupName,
            TypeStoreName,
        },
    } = feature;

    data.information = {
        tipo: translate(TypeStoreName),
        rede: GroupName,
        bandeira: BrandName
    };

    data.location = {
        latitude: coordinates[1],
        longitude: coordinates[0],
    };

    data.address = {
        endereco: AddressComplement,
        bairro: Neighborhood,
        cidade: City,
        uf: StateAcronym,
        cep: Zipcode,
    };


    data.logo = `${environment.get('IMAGES_HOST')}/logo_${data.information.bandeira.toLowerCase()}.png`;
    data.id = Id;
    data.name = Name;
    data.style = 'style=width: 42px; height: 42px;';

    return { ...feature, ...data };
};

const _getImage = (feature) =>
    new Promise((resolve) => {
        const id = feature.properties.IdOriginal;

        const images = {
            hasPhoto: true,
            original: `${CONFIG.STORE_IMAGES_HOST}/${id}.jpg`,
            thumbnail: `${CONFIG.STORE_THUMBS_HOST}/${id}.jpg`
        };

        const thumbnail = new Image();

        thumbnail.onload = () => resolve(images);

        thumbnail.onerror = () => {
            const latlng = {
                lat: feature.geometry.coordinates[1],
                lng: feature.geometry.coordinates[0]
            };
            resolve({
                hasPhoto: false,
                original: '#',
                thumbnail: `https://maps.googleapis.com/maps/api/streetview?size=${worldMap.getThumbImageSize()}&location=${latlng.lat},${latlng.lng}&sensor=false&key=${CONFIG.GOOGLE_MAPS_API_KEY}`
            });
        };

        thumbnail.src = images.thumbnail;
    });

class DealershipAfterSalesInfo {
    static getInstance() {
        if (!DealershipAfterSalesInfo._instance) {
            DealershipAfterSalesInfo._instance = new DealershipAfterSalesInfo();
        }

        return DealershipAfterSalesInfo._instance;
    }

    init() {
    }

    _getFeatureLayer(feature) {
        return currentLayer().getLayer(feature.properties.Id);
    }

    _triggerAction(value, layer, feature) {
        api.general.log.action(environment._getContextEnum(name), `Info - ${value}`, JSON.stringify(feature.properties));
        switch (value) {
            case 'locate':
                return worldMap.setView(layer.getLatLng(), 16);
        }
    }

    _showInformation(feature, layer, context) {
        api.general.log.action(environment._getContextEnum(name), 'Info - Ficha da Concessionária', JSON.stringify(feature.properties));
        const queue = [];
        queue.push(_getInfo(feature, layer));
        queue.push(_getImage(feature));

        Promise.all(queue).then(response => {
            const data = {
                ...response[0]
            };
            data.image = response[1];

            const coordinates = {
                lat: feature.geometry.coordinates[1],
                lng: feature.geometry.coordinates[0]
            };

            LayerInfo('ResumeAfterSales').show(data, {
                resultType: 'DealershipAfterSales',
                title: translate('Common.StoreInfo'),
                callback: value => this._triggerAction(value, layer, feature, name, context),
                latlng: coordinates,
                visible: true,
                callbackBack: () => {
                    infoBoard.showInfo(name, feature.properties.Id);
                    worldMap.getCurrent().fireEvent('click');
                },
            });
        });
    }

    create(features) {
        if (infoBoard.locked) {
            return;
        }

        const container = _getContainer();

        if (infoBoard.dataUnavailable({
            features,
            container,
            isEnabled: isLayerEnabled(name)
        })) {
            return;
        }

        const _entry = {};

        const template = $(templates('infoboard-content', {
            id: 'points-collapse',
            actions: 'export'
        }));

        const content = template.find('.panel-group');

        features.forEach(feature => {
            let layer = this._getFeatureLayer(feature);

            let options = {
                feature,
                name: name.toLocaleLowerCase(),
                originalName: name,
                container,
                controls: {
                    info: true,
                    hideStore: true
                }
            };

            const item = infoBoard.createItem(options);
            if (!item) {
                return;
            };

            _entry[feature.properties.Id] = feature;

            if (item.btn.info) {
                item.btn.info.on('click', e => {
                    this._showInformation(feature, item, layer);
                    selectMarker(layer, feature, name, name);
                });
            }

            if (item.btn.hideStore) {
                if (currentLayer().isHidden(feature.properties.Id)) {
                    $(item.btn.hideStore).parent().find('i').toggleClass('fa-eye-slash');
                    $(item.btn.hideStore).parent().find('a').text(translate('Action.ShowStore'));
                    item.title.toggleClass('disabled');
                }

                if (!currentLayer().isHidden(feature.properties.Id)) {
                    $(item.btn.hideStore).parent().find('i').toggleClass('fa-eye');
                    $(item.btn.hideStore).parent().find('a').text(translate('Action.HideStore'));
                }

                item.btn.hideStore.on('click', () => {
                    LayerControls(name).toggleVisibility(feature.properties.Id, layer);
                    if (!layer) {
                        layer = this._getFeatureLayer(feature);
                    }
                });
            }

            $(content).append(item.layout);
        });

        $(container).detach().append(template).appendTo('#infoboard-content');

        customScrollbar(content);
    }

    remove() {
        LayerInfo('ResumeAfterSales').remove();
    }
}

export default DealershipAfterSalesInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/AfterSales/DealershipAfterSalesInfo.js